/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />


//Used as an attribute on inputs so that when enter is hit soft keyboards on phones and tablets will disappear
module Meevo.Components.Controls {
    "use strict";

    export class MeevoHideKeyboard implements angular.IDirective {
        restrict = "A";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            element.bind('keypress', function (event: any) {
                if (event.which == 13) {
                    element.blur();
                }
            })
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoHideKeyboard();
            };
            
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoHideKeyboard", MeevoHideKeyboard.factory());
}